var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSlider = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M19.25 15a3.25 3.25 0 0 1 0 6.5H4.75a3.25 3.25 0 0 1 0-6.5h14.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  d: "M19.25 17H13v2.5h6.25a1.25 1.25 0 0 0 0-2.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8DDAF2",
  d: "M11 17H4.75a1.25 1.25 0 0 0 0 2.5H11V17z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M15 2.5a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-1L12 15l-2-2.5H9a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  d: "M15 4.5H9v6h1.961L12 11.798l1.039-1.298H15z"
}))));
export default SvgIconSlider;